// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    height: calc(100vh);
}

.username-input {
    width: 320px !important;
}

.login-container {
    margin-top: 10%;
    margin-bottom: 11.1%;
    background-color: #fff;
    border-radius: 1em;
    padding: 50px;
    box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px;
}

.rtaf-logo {
    width: 150px;
    margin-bottom: 10px;
}

.create-info-container {
    display: flex;
    margin-top: 70px;
    justify-content: center;
}
.create-info-container .lable-text {
    margin-right: 5px;
}
.btn-submit-login {
    display: flex;
    float: right;
}

`, "",{"version":3,"sources":["webpack://./src/pages/Login/Login.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,gFAAgF;AACpF;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,YAAY;AAChB","sourcesContent":[".login-wrapper {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    text-align: center;\r\n    background-position: center;\r\n    background-repeat: no-repeat;\r\n    background-size: cover;\r\n    height: calc(100vh);\r\n}\r\n\r\n.username-input {\r\n    width: 320px !important;\r\n}\r\n\r\n.login-container {\r\n    margin-top: 10%;\r\n    margin-bottom: 11.1%;\r\n    background-color: #fff;\r\n    border-radius: 1em;\r\n    padding: 50px;\r\n    box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px;\r\n}\r\n\r\n.rtaf-logo {\r\n    width: 150px;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.create-info-container {\r\n    display: flex;\r\n    margin-top: 70px;\r\n    justify-content: center;\r\n}\r\n.create-info-container .lable-text {\r\n    margin-right: 5px;\r\n}\r\n.btn-submit-login {\r\n    display: flex;\r\n    float: right;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
